import { autorun } from 'mobx'
import qs from 'qs'
import _get from 'lodash/get'
import _mapValues from 'lodash/mapValues'
import { matchPath } from 'react-router-dom'
// import config from '~/config'
// import { param } from '~/user.json'
// const {
//   catchment_id: defaultCatchmentId
// } = param
// const defaultResponse = _get(config, 'app.defaults.responseDataTypes', {})
// const defaultForcing = _get(config, 'app.defaults.forcingDataTypes', {})

// TODO: syncStoreWithHistory is tightly coupled with store, no need to accept from args
const syncStoreWithHistory = ({ store, history }) => {
  // history -> store
  const { pathname, search } = history.location
  const mode = _get(matchPath(pathname, { path: '/:mode' }), 'params.mode')
  // console.log({ _mode })
  // const mode = ['monitoring', 'forecasting', 'scenario'].includes(_mode) ? _mode : 'monitoring'
  // const mode = _mode
  const query = qs.parse(search, {
    ignoreQueryPrefix: true,
    arrayLimit: 0
  })
  const {
    // catchmentId = defaultCatchmentId,
    catchmentId,
    stationIds: stationIdsUnparsed,
    poiIds: poiIdsUnparsed,
    scenarioIds: scenarioIdsUnparsed,
    flocIds: flocIdsUnparsed,
    response: responseUnparsed,
    forcing: forcingUnparsed,
    offset: daysOffset,
    poi: poiId
  } = query
  // console.log({ stationId, poiId })
  const response = responseUnparsed && _mapValues(responseUnparsed, JSON.parse)
  const forcing = forcingUnparsed && _mapValues(forcingUnparsed, JSON.parse)
  // console.log({ stationIdsUnparsed })
  const stationIds = stationIdsUnparsed ? JSON.parse(stationIdsUnparsed) : []
  const poiIds = poiIdsUnparsed ? JSON.parse(poiIdsUnparsed) : []
  const scenarioIds = scenarioIdsUnparsed ? JSON.parse(scenarioIdsUnparsed) : []
  const flocIds = flocIdsUnparsed ? JSON.parse(flocIdsUnparsed) : []
  store.update({
    mode, catchmentId, stationIds, poiIds, scenarioIds, flocIds, dataTypeIds: { response, forcing }, daysOffset, poiId
  })
}

const routerSync = ({ store, history }) => {
  // TODO: get history from withRouter in hoc withSyncedHistory
  syncStoreWithHistory({ store, history })
  autorun(() => {
    // store -> history
    const { pathname, search } = history.location
    if (store.currentPath !== `${pathname}${search}`) {
      history.replace(store.currentPath)
    }
  })

  history.listen((location, action) => {
    syncStoreWithHistory({ store, history })
  })
  return history
}

export default routerSync



// WEBPACK FOOTER //
// ./src/utils/routerSync.js